import React, { useState } from "react"
import axios from "axios"
import { useNavigate } from 'react-router-dom';

import logo from "../logo.png"
import '../App.css';


function RegisterComponent() {

    let navigate = useNavigate()

    const [userCompany, setUserCompany] = useState("")
    const [username, setUsername] = useState("")
    const [password, setPassword] = useState("")
    const [kytopenPassword, setKytopenPassword] = useState("")
    const [registerError, setRegisterError] = useState("")

    const updateUserCompany = (event) => {
        setUserCompany(event.target.value)
    }
  
    const updateUsername = (event) => {
        setUsername(event.target.value)
    }
  
    const updatePassword = (event) => {
        setPassword(event.target.value)
    }

    const updateKytopenPassword = (event) => {
        setKytopenPassword(event.target.value)
    }
  
    const handleSubmit = async () => {
      try {
        const payload = {company: userCompany, name:username, password:password, adminPassword: kytopenPassword}
        const response = await axios.post("http://18.234.199.102:5000/register", payload, {headers:{
          'Access-Control-Allow-Origin' : '*',
          'Content-Type': 'application/json'
      }})
        if (response.data !== "User successfully created!") {
          setRegisterError(response.data)
          return " "
        } else {
            window.alert(`User ${username} has successfully been created!`)
            navigate("/")
        }
      } catch (error) {
        console.log(error)
      }
    }

    return (
        <div className="login">
          <header className="Login-header">
            <img src={logo} className="app__logo-still" alt="logo" />
            <div className="register__container">

            
            <form>
              <h1 className="login__text">Register New User</h1>
              <input
              className="register__input"
              name="User Company"
              type="text"
              placeholder="User Company"
              value={userCompany}
              onChange={updateUserCompany}
              autoComplete="off"
              ></input>
              <input
              className="register__input"
              name="username"
              type="text"
              placeholder="Username"
              value={username}
              onChange={updateUsername}
              autoComplete="off"
              ></input>
              <div></div>
              <input
              className="register__input"
              name="password"
              type="password"
              placeholder="Password"
              value={password}
              onChange={updatePassword}
              autoComplete="off"
              ></input>
              <div></div>
              <input
              className="register__input"
              name="Kytopen Admin Password"
              type="password"
              placeholder="Kytopen Admin Password"
              autoComplete="off"
              value={kytopenPassword}
              onChange={updateKytopenPassword}
              >
              </input>
            </form>
            </div>        
              <button className="button" onClick={handleSubmit}>Submit</button>
          </header>
        </div>
      );
}

export default RegisterComponent